import React, { memo } from 'react';
import { Card } from 'react-bootstrap';
import { colorFix, numberFormat } from '../../../../utils';
import Loading from '../../../loading';

function CardInfo({ idata, typeIndex, psIndex }) {
  // console.log(psIndex);

  return (
    <Card className={'card-index-info ml-1 type-index-' + typeIndex}>
      <Card.Body className={typeIndex !== 1 ? 'pt-0' : ''}>
        {typeIndex === 1 && (
          <Card.Header className="d-flex flex-column position-relative">
            <span className="txt-content fz-12">{idata.head}</span>
            {/* <span className="fz-12 font-weight-bold text-white">
              {idata.subHead}
            </span> */}
          </Card.Header>
        )}
        <Card.Body>
          <div
            className="d-flex flex-column pr-2 pl-2 pt-1 pb-1"
            style={{
              borderRadius: '4px',
              border: 'solid 1px #42465b',
              overflow: 'hidden',
            }}
          >
            {idata.data.map((item, i) => {
              if (typeIndex === 3 && i > 0) return null;
              return (
                <div key={i} className="d-flex justify-content-between">
                  <span className="fz-12 txt-content">{item.name}</span>
                  <span className={'fz-12 font-weight-bold ' + item.cl}>
                    {item.value}
                  </span>
                </div>
              );
            })}
          </div>
        </Card.Body>

        {typeIndex == 1 && (
          <>
            <Card.Header className="d-flex flex-column position-relative">
              <span className="txt-content fz-12">{`Phái sinh`}</span>
            </Card.Header>
            <Card.Body>
              <div
                className="d-flex flex-column pr-2 pl-2 pt-1 pb-1"
                style={{
                  borderRadius: '4px',
                  border: 'solid 1px #42465b',
                  overflow: 'hidden',
                }}
              >
                {psIndex.map((item, i) => {
                  const _cl = colorFix(
                    item.lastPrice,
                    item.r,
                    item.c,
                    item.f,
                    item.r
                  );
                  return (
                    <div key={i} className="d-flex justify-content-between">
                      <span className="fz-12 font-weight-bold txt-content">
                        {item.sym}
                      </span>
                      <span className={'fz-12 font-weight-bold ' + _cl}>
                        {numberFormat(item.lastPrice, 1)}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {numberFormat(item.change, 1)}
                      </span>
                    </div>
                  );
                })}
                {!psIndex.length && <Loading />}
              </div>
            </Card.Body>
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default memo(CardInfo);
